import { forwardRef } from "react";
import { FORMAT_STYLES, IG_HANDLE, LOGO } from "@/lib/brand";

const s = (f) => FORMAT_STYLES[f] || FORMAT_STYLES.Post;

export const StoryCard = forwardRef(({ plan }, ref) => {
  const { result: r, request: q } = plan;
  return (
    <div ref={ref} data-testid="story-card"
      style={{ width: 1080, height: 1920, background: "#102e24", color: "#f4f1e8", fontFamily: "'Bricolage Grotesque', sans-serif", padding: 80, boxSizing: "border-box", display: "flex", flexDirection: "column" }}>
      <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
        <img src={LOGO} alt="" style={{ height: 140 }} />
        <span style={{ background: "#e7c85e", color: "#102e24", borderRadius: 999, padding: "16px 32px", fontSize: 34, fontWeight: 800 }}>MY 30-DAY PLAN</span>
      </div>
      <p style={{ marginTop: 60, fontSize: 30, letterSpacing: 6, textTransform: "uppercase", color: "#e7c85e" }}>{q.business_name}</p>
      <h1 style={{ fontSize: 84, lineHeight: 1.02, fontWeight: 800, margin: "16px 0 0" }}>{r.headline}</h1>
      <div style={{ display: "grid", gridTemplateColumns: "repeat(6, 1fr)", gap: 16, marginTop: 60 }}>
        {r.days.map((d) => (
          <div key={d.day} style={{ background: s(d.format).bg, color: s(d.format).fg, borderRadius: 22, height: 180, padding: 14, boxSizing: "border-box", display: "flex", flexDirection: "column", justifyContent: "space-between", overflow: "hidden" }}>
            <span style={{ fontFamily: "'Instrument Serif', serif", fontSize: 52, lineHeight: 1 }}>{d.day}</span>
            <span style={{ fontSize: 17, fontWeight: 700, lineHeight: 1.15, maxHeight: 80, overflow: "hidden" }}>{d.title}</span>
          </div>
        ))}
      </div>
      <div style={{ marginTop: "auto", display: "flex", alignItems: "flex-end", justifyContent: "space-between" }}>
        <div>
          <p style={{ fontFamily: "'Caveat', cursive", fontSize: 54, color: "#e7c85e", margin: 0 }}>planned with</p>
          <p style={{ fontSize: 64, fontWeight: 800, margin: 0 }}>{IG_HANDLE}</p>
        </div>
        <p style={{ fontSize: 28, opacity: .7, textAlign: "right", margin: 0 }}>Play free at<br />catalystcrew.in</p>
      </div>
    </div>
  );
});
StoryCard.displayName = "StoryCard";
